import ign from './ign';
import koumoul from './koumoul';
import pmdc from './pmdc';
export default {
  ign,
  koumoul,
  pmdc
};